import { Input } from '@planningcenter/tapestry-react';
import React from 'react';
import 'stream-chat-react';
import { noop } from '../../utils/index.js';
import '../../chat_context.js';
import { useChatApi } from '../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { Section } from './section.js';

const Title = ({ channel, isEditable, }) => {
    const [title, setTitle] = React.useState(channel.data.name);
    const api = useChatApi();
    return (React.createElement(Section, { title: "Title" },
        React.createElement(Input, { size: "lg", value: title, maxLength: 255, disabled: !isEditable, onChange: (e) => setTitle(e.target.value), onBlur: () => {
                if (title === channel.data.name)
                    return;
                api.chat
                    .patch(`me/conversations/${channel.id}`, { title })
                    .catch(noop);
            }, onKeyDown: (e) => e.key === "Enter" && e.target.blur() })));
};

export { Title };
//# sourceMappingURL=title.js.map
